import {createDialog} from './dialog';
import {addBatchItem} from './batch-menu';
import {markReloadPendingOnReturn} from './datatable';
import {generatePDFUrl, triggerDownload} from './helpers';

// @ts-ignore
let $ = window.jQuery;

function sprintf(value: string, ...args): string {
    if (args.length === 0) {
        return value;
    }

    return sprintf(value.replace(/%s/, args.shift()), ...args);
}

export function renderTestPrintBlock() {
    if (PDFGeneratorFormSettings.pdf_print_test_layout === '') {
        return '';
    }

    return `<div class="gf-pdf-notice-info">
${PDFGenerator.text_test_print_pdf.replace('%s', PDFGeneratorFormSettings.pdf_print_test_layout)}

</div>`;
}

export function renderTestPrintBlockDialog(next: () => void, entryIDs: Array<number>, layoutId: string) {

    // The test print should never be the blank layout.
    const url = generatePDFUrl(PDFGeneratorFormSettings.actions['preview_certificate'], [entryIDs[0]], layoutId === 'blank' ? 'default' : layoutId, true);

    const footer = $(`<div class="gf-pdf-modal-footer">
<button class="continue-layout-selected gf-pdf-button -secondary">${PDFGenerator.text_continue_without_test_print}</button>
<a href="${url}" class="gf-pdf-button" target="_blank">${PDFGenerator.text_print_test_file}</a>
</div>`);

    const dialog = createDialog(`<h2>${PDFGenerator.text_test_print_pdf_dialog_title}</h2>`, `
    <div>${PDFGenerator.text_test_print_pdf}</div>`, {
        showCloseButton: true,
        closeButtonText: PDFGenerator.text_cancel,
        next,
        footer
    });
    dialog[0].showModal();
}

export function renderEnterCertificateNumberDialog(entryIDs: Array<number>, action: PDFAction, assignedCertificateNumber: string = '') {
    let message = entryIDs.length > 1
        ? PDFGenerator.text_modal_certificate_details_description_multiple
        : PDFGenerator.text_modal_certificate_details_description_single;

    const readonly = assignedCertificateNumber ? 'readonly' : '';
    const disabledOnLoad = assignedCertificateNumber ? '' : 'disabled';

    if (assignedCertificateNumber) {
        message = sprintf(PDFGenerator.text_modal_certificate_number_already_assigned, assignedCertificateNumber);
    }

    const dialog = createDialog(`<h2>${PDFGenerator.text_modal_certificate_details_title}</h2>`, `
           
            ${sprintf(message, entryIDs.length)}
            
            <form>
                <div><label for="certificate-number">${PDFGenerator.text_label_certificate_serial_number}</label>
                <input type="text" class="gf-pdf-input-field gf-pdf-input-certificate" value="${assignedCertificateNumber}" ${readonly} /><span style="display: none;" class="gf-pdf-spinner -input"></span></div>
                
                <div class="gf-pdf-modal-footer">
                <button type="button" class="gf-pdf-button -cancel gf-pdf-modal-close" value="cancel">${PDFGenerator.text_cancel}</button>
                <button type="submit" class="gf-pdf-button gf-pdf-submit-certificate" ${disabledOnLoad}>${PDFGenerator.text_continue}</button>
</div>
            </form>
`);
    dialog.on('input', '.gf-pdf-input-certificate', function (e) {
        $('.gf-pdf-submit-certificate').prop('disabled', !(($(this).val() as string).replace(' ', '').length > 0));
    }).on('click', '.gf-pdf-submit-certificate', function (e) {
        e.preventDefault();

        const $submit = $(this);
        const $dialog = $submit.closest('dialog');

        if (assignedCertificateNumber) {
            dialog.remove();
            renderConfirmAndPrintDialog(entryIDs, assignedCertificateNumber, [assignedCertificateNumber], action.key);
            return;
        }

        const originalText = $submit.text();
        $submit.text(PDFGenerator.text_verifying).prop('disabled', true);
        $dialog.find('.gf-pdf-spinner .-input').show();

        const certificateNumber = $dialog.find('.gf-pdf-input-certificate').val() as string;
        $.ajax({
            url: PDFGenerator.ajax_url,
            type: 'POST',
            data: {
                action: 'validate_certificate_number',
                certificate_number: certificateNumber,
                entry_ids: entryIDs
            }
        }).done(function (data: WordpressAJAXResponse, textStatus, jqXHR) {
            if (data.success) {
                dialog.remove();
                renderConfirmAndPrintDialog(entryIDs, certificateNumber, data.data.serial_batch_numbers, action.key);
            } else {
                $submit.text(originalText);
                $dialog.find('.gf-pdf-spinner .-input').hide();
                $dialog.find('.gf-pdf-error').remove();
                $dialog.find('.gf-pdf-modal-footer').before($(`<div class="gf-pdf-error">${data.data.message}</div>`))
            }
        });

    });
    dialog[0].showModal();
}

export function addPrePrintedButton() {
    addBatchItem($(`<button type="button" data-template="blank" class="gf-pdf-button print-selected-blank-pdfs">${PDFGenerator.text_print_blank_pdfs}</button>`));
}

function renderConfirmAndPrintDialog(entryIDs: Array<number>, certificateNumber: string, batchNumbers: Array<string>, actionKey: string) {
    const multiPageCheck = entryIDs.length > 1 ? `<li><label><input type="checkbox" name="confirmed[]"> ${sprintf(PDFGenerator.text_checkbox_correct_order, batchNumbers[0], batchNumbers[batchNumbers.length - 1])}</label></li>` : '';

    const dialog = createDialog(`<h2>${PDFGenerator.text_modal_final_verification_title}</h2>`, `
            ${PDFGenerator.text_before_preview_bullets}
            <ul class="gf-pdf-list-nobullets">
                <li><label><input type="checkbox" name="confirmed[]"> ${sprintf(PDFGenerator.text_checkbox_correct_start_number, batchNumbers[0])}</label></li>
                ${multiPageCheck}
                <li><label><input type="checkbox" name="confirmed[]"> ${PDFGenerator.text_checkbox_correct_orientation}</label></li>
            </ul>
            ${PDFGenerator.text_open_preview_and_print}
            <form>
                <div class="gf-pdf-modal-footer">
                <button type="submit" class="gf-pdf-button -cancel gf-pdf-modal-close" value="cancel">${PDFGenerator.text_cancel}</button>
                <button type="submit" class="gf-pdf-button gf-pdf-submit-certificate" disabled>${PDFGenerator.text_preview_print}</button></div></form>`);

    dialog.on('change', 'input[name="confirmed[]"]', function (e) {
        $('.gf-pdf-submit-certificate').prop('disabled', dialog.find('input[name="confirmed[]"]:checked').length !== dialog.find('input[name="confirmed[]"]').length);
    }).on('submit', function (e) {
        e.preventDefault();
        dialog.remove();
        const params = entryIDs.map(id => `entry_ids[]=${id}`).join('&');
        triggerDownload(`${PDFGenerator.ajax_url}?action=pdf_action&action_key=${actionKey}&start_number=${certificateNumber}&${params}`);

        markReloadPendingOnReturn();
    });

    dialog[0].showModal();
}
